import * as React from 'react';
import { WIDTH_DESKTOP_WIDE } from '../../constants/device-widths';

/**
 *  /dispansary wide layout grid is currently:
 *    1066 dispensary  - somehow
 *    339px cart
 *    1405px total
 */

const WideScreenOnly = ({children, wideEnabled=true}) => {
  const [isWideScreen, setWideScreen] = React.useState(false);

  React.useEffect(() => {
    if (window.innerWidth >= WIDTH_DESKTOP_WIDE) {
      setWideScreen(true);
    }

    const handleResize = () => {
      // TODO: thottle this?
      if (window.innerWidth >= WIDTH_DESKTOP_WIDE) {
        setWideScreen(true); 
      } else {
        setWideScreen(false); 
      }
    };

    window.addEventListener('resize', handleResize);
    // remove on unmount
    return () => { window.removeEventListener('resize', handleResize)};
  }, [isWideScreen]);

  const shouldRender = (isWideScreen && wideEnabled) ||
                       (!isWideScreen && !wideEnabled); 
  return (
    shouldRender &&  
    <>
      {children}
    </>
  );
}

export default WideScreenOnly;